export const featurePageMapping: { [key: string]: PageMapping } = {
	"/benchmark": {
		actions: [],
		buttons: [],
		icon: "leaderboard",
		label: "Benchmark",
		labelKey: "nav.benchmark.module.label",
		nav: false,
		title: "Benchmark",
		titleKey: "nav.benchmark.module.title"
	},
	"/benchmark/compare": {
		actions: [],
		buttons: [],
		icon: "compare_arrows",
		label: "Compare across cohorts",
		labelKey: "benchmark:compare.header.title",
		nav: false,
		title: "Compare across cohorts",
		titleKey: "benchmark:compare.header.title"
	},
	"/benchmark/console": {
		actions: [],
		buttons: [],
		icon: "admin_panel_settings",
		label: "Console",
		labelKey: "nav.benchmark.console.label",
		nav: false,
		title: "Community Console",
		titleKey: "nav.benchmark.console.title"
	},
	"/benchmark/console/access-log": {
		actions: [],
		buttons: [],
		icon: "history",
		label: "Access Log",
		labelKey: "nav.benchmark.console.accessLog.label",
		nav: false,
		title: "Access Log",
		titleKey: "nav.benchmark.console.accessLog.title"
	},
	"/benchmark/console/billing": {
		actions: [],
		buttons: [],
		icon: "receipt_long",
		label: "Billing",
		labelKey: "nav.benchmark.console.billing.label",
		nav: false,
		title: "Billing",
		titleKey: "nav.benchmark.console.billing.title"
	},
	"/benchmark/console/cohorts": {
		actions: [],
		buttons: [],
		icon: "table_chart",
		label: "Cohort Tables",
		labelKey: "nav.benchmark.console.cohortTables.label",
		nav: false,
		title: "Cohort Tables",
		titleKey: "nav.benchmark.console.cohortTables.title"
	},
	"/benchmark/console/lookup": {
		actions: [],
		buttons: [],
		icon: "manage_search",
		label: "Company Lookup",
		labelKey: "nav.benchmark.console.lookup.label",
		nav: false,
		title: "Company Lookup",
		titleKey: "nav.benchmark.console.lookup.title"
	},
	"/benchmark/console/members": {
		actions: [],
		buttons: [],
		icon: "groups",
		label: "Members",
		labelKey: "nav.benchmark.console.members.label",
		nav: false,
		title: "Members",
		titleKey: "nav.benchmark.console.members.title"
	},
	"/benchmark/console/metrics": {
		actions: [],
		buttons: [],
		icon: "tune",
		label: "Metric Catalog",
		labelKey: "nav.benchmark.console.metricCatalog.label",
		nav: false,
		title: "Metric Catalog",
		titleKey: "nav.benchmark.console.metricCatalog.title"
	},
	"/benchmark/console/roster": {
		actions: [],
		buttons: [],
		icon: "badge",
		label: "Roster",
		labelKey: "nav.benchmark.console.roster.label",
		nav: false,
		title: "Roster",
		titleKey: "nav.benchmark.console.roster.title"
	},
	"/benchmark/home": {
		actions: [],
		buttons: [],
		icon: "home",
		label: "Results by period",
		labelKey: "benchmark:results.header.title",
		nav: false,
		title: "Results by period",
		titleKey: "benchmark:results.header.title"
	},
	"/benchmark/results": {
		actions: [],
		buttons: [],
		icon: "assessment",
		label: "Results by period",
		labelKey: "benchmark:results.header.title",
		nav: false,
		title: "Results by period",
		titleKey: "benchmark:results.header.title"
	},
	"/benchmark/reviews": {
		actions: [],
		buttons: [],
		description: "Review, edit, approve, and release each company's benchmark review.",
		descriptionKey: "nav.benchmark.reviews.description",
		icon: "rate_review",
		label: "Report Queue",
		labelKey: "nav.benchmark.reviews.label",
		nav: false,
		title: "Report Queue",
		titleKey: "nav.benchmark.reviews.title"
	}
};

export const flatPageMapping: { [key: string]: PageMapping } = {
	...featurePageMapping
};

export default flatPageMapping;
